export default "__VITE_ASSET__CqP9rDhO__"